import React from 'react';
export var NonClickableDate = function (_a) {
    var date = _a.date;
    return (React.createElement("td", { "aria-hidden": true, className: "ffe-calendar__day", key: date.timestamp, role: "button" }));
};
